<template>
	<div class="favorite-container">
		<template v-if="updatingFavorite">
			<div class="changing-favorite">
				<i class="fas fa-spinner fa-pulse"></i>
			</div>
		</template>
		<template v-else>
			<div class="add-favorite" v-on:click="addFavorite" v-if="!isFav">
				<b-icon icon="star" pack="far"
				        class="not-favorite"
				        title="Add to Favorites" />
			</div>
			<div class="remove-favorite" v-on:click="removeFavorite" v-if="isFav">
				<b-icon icon="star" pack="fas"
				        class="favorite"
				        title="Remove from Favorites" />
			</div>
		</template>
	</div>
</template>

<script>
import { DATATABLE_ACTION } from '../../store/actions/datatable'

export default {
  name: 'Favorite',
  props: {
    model: {
      type: String
    },
    modelId: {
      type: [String, Number]
    },
    favorite: {
      type: Boolean,
      default: false
    }
  },
  components: {
    //
  },
  data () {
    return {
      updatingFavorite: false,
      phoFavorite: this.favorite
    }
  },
  mounted () {
    //
  },
  watch: {
    //
  },
  computed: {
    isFav () {
      if (this.phoFavorite !== this.favorite) return this.phoFavorite
      if (this.favorite) return true

      return false
    }
  },
  methods: {
    handleError (err) {
      if (err.hasOwnProperty('response')) {
        if (err.response.data.response === 'error') {
          this.$awn.warning(err.response.data.message)
        }
      } else {
        this.$awn.alert(err.toString())
      }
    },
    addFavorite () {
      this.phoFavorite = true
      this.doAction({
        'action': 'add-favorite',
        'handle': 'add-favorite',
        'model': this.model,
        'selectedIds': [this.modelId]
      })
    },
    removeFavorite () {
      this.phoFavorite = false
      this.doAction({
        'action': 'remove-favorite',
        'handle': 'remove-favorite',
        'model': this.model,
        'selectedIds': [this.modelId]
      })
    },
    doAction (data) {
      this.updatingFavorite = true
      this.$store.dispatch(DATATABLE_ACTION, data)
        .then(response => {
          this.updatingFavorite = false

          if (response.message !== undefined) {
            this.$awn.success(response.message)
          }

          this.$emit('change', data.action)
        })
        .catch(err => {
          this.updatingFavorite = false
          this.handleError(err)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Elements/Favorite.vue